import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { homeActions } from '../store';

const QUEUE_POLL_MS = 10 * 60 * 1000;
const SKIP_LOADER = { skipLoader: true };

/** Soft-polls GET_QUEUE every 10 minutes while Home is mounted and the tab is visible. */
export default function useHomeQueuePolling(activeSalonId) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!activeSalonId) return undefined;

    const fetchQueue = () => {
      if (typeof document !== 'undefined' && document.hidden) return;
      dispatch(homeActions.GET_QUEUE.REQUEST({}, null, SKIP_LOADER));
    };

    let intervalId = window.setInterval(fetchQueue, QUEUE_POLL_MS);

    const restartTimer = () => {
      if (intervalId != null) window.clearInterval(intervalId);
      intervalId = window.setInterval(fetchQueue, QUEUE_POLL_MS);
    };

    const onVisibilityChange = () => {
      if (document.hidden) {
        if (intervalId != null) {
          window.clearInterval(intervalId);
          intervalId = null;
        }
        return;
      }
      fetchQueue();
      restartTimer();
    };

    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      if (intervalId != null) window.clearInterval(intervalId);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, [dispatch, activeSalonId]);
}
